<template>
  <div class="i-site-multi-picker">
    <div class="field-label">
      {{ label }}
    </div>
    <multiselect
      v-model="selected"
      label="name"
      trackBy="siteId"
      :options="sites"
      :multiple="false"
      :placeholder="placeholder"
      @search-change="onSearch"
      @select="onSelect"
      @remove="onRemove"
    />
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import {listSites} from "@/services/api/app/office/recovery/share-point/sharePoint";
import {defaultPagination} from "@/services/pagination";

export default {
  name: 'ISitePicker',
  components: {Multiselect},
  props: {
    value: {},
    label: {
      type: String,
      default: 'Site'
    },
    placeholder: {
      type: String,
      default: 'Search for sites here'
    },
    filter: {
      type: Object,
      default: {
        "statuses": [
          1, 2, 4
        ]
      }
    }
  },

  data() {
    return {
      selected: null,
      sites: []
    }
  },

  methods: {
    onSearch(searchTerm) {
      this.sites = [];
      this.loadSites(searchTerm)
    },
    loadSites(search = null) {
      listSites({
        pagination: {
          ...defaultPagination(),
          pageSize: 30,
          sortBy: 'name',
          sortDescending: false
        },
        search,
        filter: this.filter
      })
        .then(({result, pagination}) => {
          this.sites = result;
        })
    },
    onSelect(data) {
      this.$emit('input', data)
    },
    onRemove(data) {
      this.$emit('input', null)
    }
  },

  created() {
    if (this.value?.status != 4) {
      this.selected = this.value;
    }

    this.loadSites();
  },
}
</script>

<style lang="scss">
@import "IUserMultiPicker.scss";
</style>
